module.exports = __webpack_public_path__ + "static/media/Typhoon_MK_II_25mm_Stabilised_Naval_Gun_Systems_01.7d163b7d.jpg";